module.exports = __webpack_public_path__ + "img/pic_14.baf07a78.jpg";